import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import OverviewFilter from "./OverviewFilter";
import { columns, formatRowData } from "./pendingOrdersData";
import { OrderStatusConstant, OrderStatusConstants } from "../../common/constants";
import Pagination from "./Pagination";
import AppTable from "./AppTable";
import { groupbyArrayN } from "./Data";
import { useDispatch, useSelector } from "react-redux";
import { GetCurrentOrderList, GetLawyersByFirmID, lawFirmSelector } from "../../features/lawFirm/lawFirmSlice";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { getLawfirmForInternalUser } from "../../common/utils";

function PendingOrders({ pendingOrders, firmIDAndName  }) {
  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalOrders: 0,
    column: null,
    order: "ascending",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  const [ordersPerPage, setOrdersPerPage] = useState(10);
  const { userLogin } = useSelector(authLoginSelector);
  const { DashboardLawfirm, totalOrderCount, loadingOrderList } = useSelector(lawFirmSelector);

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    if (pendingOrders?.length > 0) {
      // Use totalOrderCount from API if available, otherwise fallback to array length
      // const total = totalOrderCount > 0 ? totalOrderCount : pendingOrders.length;
      const total = pendingOrders[0]?.totalRows || 0;
      console.log("🚀 ~ PendingOrders ~ total:", total);
      setPageData({
        isLoading: loadingOrderList,
        rowData: formatRowData(pendingOrders, currentLanguage),
        totalPages: Math.ceil(total / ordersPerPage),
        totalOrders: total,
      });
    } else {
      setPageData({
        isLoading: loadingOrderList,
        rowData: [],
        totalPages: 0,
        totalOrders: 0,
      });
    }
  }, [pendingOrders, currentLanguage, totalOrderCount, ordersPerPage, loadingOrderList]);

  const onSort = (column, order) => {
    if (column !== null) {
      setPageData((prevState) => ({
        ...prevState,
        column,
        order,
      }));
      // Reset to first page when sorting changes
      setCurrentPage(0);
    }
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Trigger API call when page, sort, or filters change
  useEffect(() => {
    if (filterValues && Object.keys(filterValues).length > 0) {
      let { dateValue, deals, lawyerValue, status, search } = filterValues;
      if (typeof lawyerValue === "object") {
        lawyerValue = lawyerValue?.map(x => x.value).join(",")
      }
      if (firmIDAndName === null) return;
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          2,
          dateValue || "",
          deals || "All",
          userLogin?.internalUser ? lawyerValue : userLogin?.isLawyer ? lawyerValue || userLogin?.userId.toString() : lawyerValue || "",
          status || "Final Review,Not Yet Submitted,Under Review,Waiting For Information,Needs Approval,Pending",
          search || "",
          true,
          pageData.column,
          pageData.order,
          userLogin?.internalUser ? "" : !userLogin?.isLawyer ? userLogin?.userId.toString() : "",
          currentPage + 1, // API expects 1-based page number
          ordersPerPage
        )
      );
    }
  }, [currentPage, pageData.column, pageData.order, filterValues]);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { lawyersByFirm } = useSelector(lawFirmSelector);
  const [LawyerOptions, setLawyerOptions] = useState([]);

  useEffect(() => {
    if (lawyersByFirm?.length === 0)
      dispatch(GetLawyersByFirmID(getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser)));
    else {
      let lawyeroptions = [];
      lawyeroptions.push({ label: t('All'), value: "All" });
      lawyersByFirm?.lawyers?.map((item, i) => {
        lawyeroptions.push({ label: t(item.lawyer), value: item.userID });
      });
      setLawyerOptions(lawyeroptions);
    }
  }, [firmIDAndName, lawyersByFirm]);


  const DealTypeOptions = OrderStatusConstant("DealType").map(
    (item, i) => {
      return { label: t(item.label), value: item.value };
    }
  );
  const StatusOptions = OrderStatusConstant("Status").filter(
    (x) => (x.value.toLowerCase() !== "ready for pickup" && x.value.toLowerCase() !== "cancelled" && x.value.toLowerCase() !== "needs approval")
  ).map((item, i) => {
    return { label: t(item.label), value: item.value, imageurl: item?.imageurl };
  });

  return (
    <div>

      {/* <button onClick={() => setCurrentPage(1)}>Reset</button> */}
      <OverviewFilter
        // loading={loading}
        DealTypeOptions={DealTypeOptions}
        LawyerOptions={LawyerOptions}
        StatusOptions={StatusOptions}
        onFilter={(values) =>
          setFilterValues((prev) => ({ ...prev, ...values }))
        }
        firmIDAndName={firmIDAndName}
        tab={2}
        onPageReset={() => setCurrentPage(0)}
        currentPage={currentPage}
        pageSize={ordersPerPage}
        sortColumn={pageData.column}
        sortOrder={pageData.order}
        initialStatusFilter={"Final Review,Not Yet Submitted,Under Review,Waiting For Information,Needs Approval,Pending"}
      />
      <div style={{ height: "auto" }}>
        {pageData.rowData && pageData.rowData.length > 0 && (
          <AppTable
            columns={columns}
            data={pageData.rowData}
            isLoading={pageData.isLoading}
            onSort={onSort}
            manualSorting
          />
        )}
      </div>
      <br />
      {!pageData.rowData || pageData?.rowData?.length === 0 &&
        <div className="text-center text-secondary-red font-semibold text-lg">
          {t('noResults')}
        </div>
      }

      <div>
        {(pendingOrders && pendingOrders?.length > 0 && pageData.totalOrders > 0) && (
          <Pagination
            totalRows={pageData.totalOrders}
            pageChangeHandler={handlePageChange}
            rowsPerPage={ordersPerPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
}

export default React.memo(PendingOrders);
